import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  return (
    <select
      aria-label={t('header.language')}
      value={i18n.resolvedLanguage === 'kk' ? 'kk' : 'ru'}
      onChange={(event) => void i18n.changeLanguage(event.target.value)}
      className="text-ink h-10 rounded-lg bg-transparent px-1 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current"
    >
      <option value="ru" lang="ru">
        RU
      </option>
      <option value="kk" lang="kk">
        ҚАЗ
      </option>
    </select>
  );
}
